export var brandColors = {
    night: {
        700: '#504F87',
        900: '#2C1A4F',
    },
    spark: '#FED044',
};
